var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAadhaar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 54,
    viewBox: "0 0 85 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.65312 0.047949L81.3037 0C83.0938 0.111879 84.2925 1.39049 84.4363 3.1326V50.2974C84.2765 52.0395 83.0778 53.3341 81.3037 53.43H2.95679C1.27861 53.398 0.111879 51.8957 0 50.2974L0.0958966 2.33347C0.543411 1.11879 1.37451 0.335637 2.65312 0.047949ZM1.61425 1.59827V51.8158H82.8221V1.59827H1.61425Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3617 4.71396L73.9407 4.66602C79.2469 4.92174 79.6944 12.2098 74.4841 13.0889H10.3137C5.21527 12.4655 5.24724 5.35327 10.3617 4.71396Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7485 18.1094V49.3075H5.74219V18.1094H36.7485ZM35.1343 19.5478H7.35644V47.1499L8.28343 44.9442C9.09854 43.4419 10.2653 42.1952 11.8955 41.5559C13.286 41.0125 16.962 40.4052 17.6173 38.8549C17.7611 38.5032 17.9849 36.3616 17.889 35.994C17.8091 35.7063 16.7383 34.2678 16.4665 33.8203C16.2108 33.4048 16.067 32.7495 15.8592 32.4618C15.6514 32.1741 15.2998 32.1581 15.0281 31.6786C14.6285 30.9594 13.4458 27.4592 15.2199 27.7629C14.8363 23.2718 16.5305 20.0912 21.4372 20.2351C26.3438 20.3789 27.6224 23.6713 27.079 27.9547C28.9969 27.0437 27.7024 31.1992 27.3028 31.8545C27.0311 32.318 26.7274 32.1581 26.5356 32.3819C26.3438 32.6056 26.1041 33.5007 25.8963 33.8523C24.9853 35.4346 24.33 35.6583 24.5697 37.7361C24.6816 38.727 25.0652 39.2864 25.8803 39.8298C28.7412 41.7157 31.73 40.9486 33.8557 44.4008L35.1503 47.3257V19.5318H35.1343V19.5478Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6078 18.8585L76.8107 18.8105C79.7195 19.29 79.5597 23.1578 76.6348 23.4775H43.1192C40.3862 23.2377 39.9866 19.5937 42.6238 18.8585H42.6078Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8746 45.7749C75.6258 46.67 75.1463 48.2682 73.9476 48.428H42.206C40.6717 48.428 40.368 46.0466 41.6307 45.5032L73.7718 45.3594C74.1074 45.3594 74.6668 45.5352 74.8746 45.7749Z",
    fill: "#414042"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8935 28.1957L71.5094 28.2436C73.0277 29.3304 72.5962 31.1525 70.7102 31.3762H42.5648C40.7108 31.3283 40.1194 28.8669 41.8935 28.1797V28.1957Z",
    fill: "#414042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8033 37.1597C67.5226 38.0228 67.139 39.7329 65.8763 39.8128H42.206C40.6717 39.8128 40.368 37.4314 41.6307 36.888L65.7005 36.7441C66.0362 36.7441 66.5956 36.92 66.8033 37.1597Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAadhaar);
export default __webpack_public_path__ + "static/media/Aadhaar.65afb153e24de5021b90cad76fb20ce0.svg";
export { ForwardRef as ReactComponent };